export default "__VITE_ASSET__bc993e24__"